<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
        <small>(仅供查看方便，不列入需求内，勿在此页面提任何需求)</small>
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <router-link :to="{ path: '/fair/user_limit_table/'+search.fairid}">
        <el-button type="primary">参与用户当天剩余数</el-button>
      </router-link>
      <br/><br/>
    </el-row>
    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="reward_item_id"
                         label="奖品编号"></el-table-column>
        <el-table-column prop="user_type"
                         label="用户类型">
          <template slot-scope="scope">
            <span v-for="item in options.userType"
                  v-if="item.value === scope.row.user_type">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column label="奖品id"
                         prop="prizeid"></el-table-column>
        <el-table-column label="奖品名称"
                         prop="prizename"></el-table-column>
        <el-table-column prop="limit_per_day"
                         label="每天数"></el-table-column>
        <el-table-column prop="limit_number"
                         label="剩余数"></el-table-column>
        <el-table-column prop="chance"
                         label="概率"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        fairid: this.$route.params.fairid,
      },
      options: {
        userType: [
          {label: '新用户', value: 10},
          {label: '老用户', value: 20},
        ],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
  },
  methods: {
    ...Vuex.mapActions(['getFairPrizeNumber']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getFairPrizeNumber', params)
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/fair/pages/FairRemainingPrizeTable.vue